import styled from "styled-components";
export const AppBarButtonGroup = styled.div `
  display: inline-flex;
  flex-shrink: 0;
`;
